import React, { Component } from "react";
import {
  NormalButtonBackend,
  NormalTable,
  InputSearch,
  NormalSelect,
} from "component/common";
import { withTranslation } from "react-i18next";
import { CommGroupHdrs } from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "../style.scss";

export class CommissionlistClass extends Component {
  state = {
    headerDetails: [
      { label: "Code", 
        divClass: "justify-content-end",
        sortKey: "Code",
        enabled: true,
        id: "code",
        singleClickFunc: () => this.handleSort("code"),
      },
      { label: "Description",
      sortKey: "Description",
      enabled: true,
      id: "description",
      singleClickFunc: () => this.handleSort("description"),
      },
      { label: "Type",
      sortKey: "Type",
      enabled: true,
      id: "type",
      singleClickFunc: () => this.handleSort("type"),
      },
      { label: "Active",
      sortKey: "Active",
      enabled: true,
      id: "isactive",
      singleClickFunc: () => this.handleSort("isactive"),
    },
    ],
    commissionList: [],
    option: [
      { label: 10, value: 10 },
      { label: 25, value: 25 },
      { label: 50, value: 50 },
      { label: 100, value: 100 },
    ],
    count: 10,
    is_loading: false,
    isoption: false,
    offset:0,
    data: [],
    perPage: 10,
    currentPage: 1,
    filterdata:[],
    seachdata:[],
    List: [],
    pageMeta: {},
    isActive: false,
    isInactive: false,
    isAll: false,
    activeButton: false,
    inactiveButton: false,
    search:"",
  };

  componentDidMount = () => {
    this.Listofcommision({});
  };

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  /* List Sorting */
  handleSort = (sortkey, order) => {
    let { List, headerDetails, orderBy } = this.state;
    this.setState({
      orderBy: this.state.orderBy == "asc" ? "desc" : "asc",
    });
    if (orderBy === "asc") {
      List.sort((a, b) =>
        a[sortkey] > b[sortkey] ? 1 : b[sortkey] > a[sortkey] ? -1 : 0
      );
    } else {
      List.sort((a, b) =>
        a[sortkey] < b[sortkey] ? 1 : b[sortkey] < a[sortkey] ? -1 : 0
      );
    }
    this.setState({
      List,
    });
  };

  /* List of Commission Function */
  Listofcommision = async () => {
    this.setState({
      is_loading:true,
      activeButton:false,
      inactiveButton:false,
    });
    await this.props.CommGroupHdrs().then((res) => {
      let {
        commissionList,
        pageCount,
        List,
        pageMeta,
        count,
        currentPage,
        perPage,
      } = this.state;
      commissionList = res;
      commissionList.sort((a, b) => a.code.localeCompare(b.code));
      List = commissionList.slice (
        (currentPage - 1) * perPage,
        (currentPage - 1) * perPage + perPage
      );
      pageCount = Math.ceil(commissionList.length / this.state.perPage);
      this.setState({
        commissionList,
        is_loading: false,
        List,
        pageCount,
        isActive: false,
        isInactive: false,
        isAll: true,
        pageMeta: { ...pageMeta, total_pages: pageCount, per_page: count },
      }
      // ()=>{
      //   this.filterByName({ target: {value: this.state.search, name:"seaarch"} });
      // }
      );
    });
  };

  /* List of Commission Active List */
  Listofactivecommission = async () => {
    this.setState({
      is_loading: true,
      activeButton: true,
      inactiveButton: false,
    });
    await this.props.CommGroupHdrs().then((res) => {
      let { pageCount, List, currentPage, perPage,pageMeta } = this.state;
      let Listone = [];
      for (let key of res) {
        if (key.isactive === true) {
          Listone.push({
            code: key.code,
            description: key.description,
            type: key.type,
            isactive: key.isactive,
          });
        }
      }
      this.setState({ Listone });
      List = Listone.slice(
        (currentPage - 1) * perPage,
        (currentPage - 1) * perPage + perPage
      );
      pageCount = Math.ceil(Listone.length / this.state.perPage);
      this.setState({
        pageCount,
        is_loading: false,
        List,
        isActive: true,
        isInactive: false,
        isAll: false,
        pageMeta: { ...pageMeta, total_pages: pageCount },
      }
      // () => {
      //   this.filterByName({
      //     target: { value: this.state.search, name: "search" },
      //   });
      // }
    );
  });
};

  /* List of Commission InActive List */
  Listofinactivecommission = async () => {
    this.setState({
      is_loading: true,
      activeButton: false,
      inactiveButton: true,
    });
    await this.props.CommGroupHdrs().then((res) => {
    let { pageCount, List, currentPage, perPage,pageMeta } = this.state;
    let Listone = [];
      for (let key of res) {
        if (key.isactive === false) {
          Listone.push({
            code: key.code,
            description: key.description,
            type: key.type,
            isactive: key.isactive,
          });
        }
      }
      this.setState({ Listone });
      List = Listone.slice(
        (currentPage - 1) * perPage,
        (currentPage - 1) * perPage + perPage
      );
      pageCount = Math.ceil(Listone.length / this.state.perPage);
      this.setState({
        pageCount,
        is_loading: false,
        List,
        isActive: false,
        isInactive: true,
        isAll: false,
        pageMeta: { ...pageMeta, total_pages: pageCount },
      }
      // () => {
      //   this.filterByName({
      //     target: { value: this.state.search, name: "search" },
      //   });
      // }
    );
  });
};

  /* Pagination Limit Set Function */
  temp = ({ target: { value, name } }) => {
    let { count, perPage, pageMeta } = this.state;
    if (name == "count") {
      count = value;
      perPage = value;
      this.setState({
        count,
        perPage,
        pageMeta: { ...pageMeta, per_page: perPage },
      });
      this.Listofcommision();
    }
  };

  /* Select Pagination Function */
  handlePageClick = (e) => {
    let { isActive, isInactive, isAll } = this.state;
    const selectedPage = e.page;
    const offset = selectedPage * this.state.perPage;
    this.setState(
      {
        currentPage: selectedPage,
        offset: offset,
        pageMeta: { ...this.state.pageMeta, currentPage: selectedPage },
      },
      () => {
        if (isActive) {
          this.Listofactivecommission();
        } else if (isInactive) {
          this.Listofinactivecommission();
        } else if (isAll) {
          this.Listofcommision();
        } else {
          this.handleFilterChange();
        }
      }
    );
  };

  handleFilterChange = () => {
    let {
      commissionList,
      pageCount,
      filterdata,
      search,
      seachdata,
      perPage,
      currentPage,
      pageMeta,
      count,
    } = this.state;
    filterdata = commissionList.filter((item) => {
      return Object.values(item)
        .join("")
        .toLowerCase()
        .includes(search.toLowerCase());
    });
    this.setState({ filterdata });
    seachdata = filterdata.slice(
      (currentPage - 1) * perPage,
      (currentPage - 1) * perPage + perPage
    );
    pageCount = Math.ceil(filterdata.length / this.state.perPage);
    this.setState({
      seachdata,
      pageCount,
      pageMeta: { ...pageMeta, total_pages: pageCount, perPage: count },
    });
  };

  /* Description Filter Function */
  filterByName = ({ target: { value, name } }) => {
    let {
      commissionList,
      pageCount,
      filterdata,
      search,
      seachdata,
      currentPage,
      perPage,
      pageMeta,
      count,
      activeButton,
      inactiveButton,
    } = this.state;
    if (name === "search") {
      search = value;
      this.setState({ search });
    }
    if (search.length === 0) {
      this.Listofcommision();
    }
    if (search !== "") {
      filterdata = commissionList.filter((item) => {
        const isActive = item.isactive ? "Yes" : "No";
        const lowerCaseSearch = search.toLowerCase();
        const lowerCasecode = item.code.toLowerCase();
        const lowerCasedescription = item.description.toLowerCase();
        const lowerCasetype = item.type.toLowerCase();
        const lowerCaseActive = isActive.toLowerCase();

        if (activeButton && item.isactive === false) {
          return false;
        }

        if (inactiveButton && item.isactive === true) {
          return false;
        }

        return (
          lowerCasecode.includes(lowerCaseSearch) ||
          lowerCasedescription.includes(lowerCaseSearch) ||
          lowerCasetype.includes(lowerCaseSearch) ||
          lowerCaseActive.includes(lowerCaseSearch)
        );
      });
    } else {
      filterdata = commissionList;
    }
    this.setState({ filterdata });
    if (filterdata.length < 10) {
      seachdata = filterdata;
    } else {
      seachdata = filterdata.slice(
        (currentPage - 1) * perPage,
        (currentPage - 1) * perPage + perPage
      );
    }
    pageCount = Math.ceil(filterdata.length / this.state.perPage);
    this.setState({
      seachdata,
      pageCount,
      isActive: false,
      isAll: false,
      isInactive: false,
      pageMeta: { ...pageMeta, total_pages: pageCount, perPage: count },
    });
  };

  render() {
    let {
      headerDetails,
      List,
      is_loading,
      option,
      count,
      pageMeta,
      isActive,
      isAll,
      isInactive,
      search,
      seachdata
    } = this.state;
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid department-container bg-white">
          <div className="row">
            <div className={"itemmaster-container col-12"}>
              <div className="row align-items-center">
                <div className="col-12">
                  <h4 className="label-head text-center text-md-left text-lg-left mt-3 mb-0">
                    {t("Item Classification")}
                  </h4>
                </div>
                <div className="col-12">
                  <p className="label-title text-center text-md-left text-lg-left mt-2">
                    {t("Commission")}
                  </p>
                </div>
                <div className="mt-3 col-12 d-md-flex justify-content-md-between m-0 p-0">
                  <div className="d-md-flex col-12 col-md-4">
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"All"}
                        onClick={this.Listofcommision}
                        isActive={isAll}
                      />
                    </div>
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"Active"}
                        isActive={isActive}
                        onClick={this.Listofactivecommission}
                      />
                    </div>
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"Inactive"}
                        onClick={this.Listofinactivecommission}
                        isActive={isInactive}
                      />
                    </div>
                  </div>
                  <div className="p-1 col-12 col-md-4">
                  <InputSearch
                      type="search"
                      placeholder={t("Search")}
                      onChange={this.filterByName}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-center justify-content-md-start col-12 mt-3">
                  <p className="mt-2 mr-1">{t("Show")}</p>
                  <div className="p-1">
                    <NormalSelect
                      options={option}
                      value={count}
                      onChange={this.temp}
                      name="count"
                    />
                  </div>
                  <p className="mt-2 ml-1">{t("Entries")}</p>
                </div>
              </div>
              <div className="tab-table-content">
                {search.length > 0 ? (
                  <div className="table-container">
                    <div className="py-4">
                      <div className="table-container">
                        <NormalTable
                          headerDetails={headerDetails}
                          pageMeta={pageMeta}
                          queryHandler={(event) => this.handlePageClick(event)}
                        >
                          {is_loading ? (
                            <tr>
                              <td colSpan="7">
                                <div class="d-flex mt-5 align-items-center justify-content-center">
                                  <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ) : seachdata.length > 0 ? (
                            seachdata.map(
                              ({ code, description, type, isactive }, index) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <div
                                        className="text-left text-primary"
                                        onClick={() =>
                                          this.props.history.push(
                                            `/admin/backend/commissionId/${code}`
                                          )
                                        }
                                      >
                                        {code}
                                      </div>
                                    </td>
                                    <td>
                                  <div className="text-left">{description}</div>
                                </td>
                                <td>
                                  <div className="text-left">{type}</div>
                                </td>
                                <td>
                                  <div className="text-left">
                                    {isactive == true ? "Yes" : "No"}
                                  </div>
                                </td>
                              </tr>
                                );
                              }
                            )
                          ) : null}
                        </NormalTable>
                      </div>
                    </div>
                  </div>
                ) : (
                <div className="py-4">
                  <div className="table-container">
                    <NormalTable
                      headerDetails={headerDetails}
                      pageMeta={pageMeta}
                      queryHandler={(event) => this.handlePageClick(event)}
                    >
                      {is_loading ? (
                        <tr>
                          <td colSpan="7">
                            <div class="d-flex mt-5 align-items-center justify-content-center">
                              <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : List.length > 0 ? (
                        List.map(
                          ({ code, description, type, isactive }, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <div
                                    className="text-left text-primary"
                                    onClick={() =>
                                      this.props.history.push(
                                        `/admin/backend/commissionId/${code}`
                                      )
                                    }
                                  >
                                    {code}
                                  </div>
                                </td>
                                <td>
                                  <div className="text-left">{description}</div>
                                </td>
                                <td>
                                  <div className="text-left">{type}</div>
                                </td>
                                <td>
                                  <div className="text-left">
                                    {isactive == true ? "Yes" : "No"}
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        )
                      ) : null}
                    </NormalTable>
                  </div>
                </div>
                )}
                </div>
              <div
                className="icon"
                onClick={() =>
                  this.props.history.push(
                    `/admin/backend/itemclassification/commissiondataentry`
                  )
                }
              >
                +
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      CommGroupHdrs,
    },
    dispatch
  );
};

export const Commissionlist = withTranslation()(
  connect(null, mapDispatchToProps)(CommissionlistClass)
);
